/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { getVCObserver } from '@atlaskit/react-ufo/vc';
function bind(target, event, controller, listener) {
  // Safe check for rare cases where window doesn't exist
  if (!target || typeof target.addEventListener !== 'function') {
    return function () {};
  }
  var options = {
    capture: true,
    passive: true,
    once: true,
    signal: controller.signal
  };
  target.addEventListener(event, listener, options);
  return function unbind() {
    target.removeEventListener(event, listener, options);
  };
}
var AbortEvent = ['wheel', 'keydown', 'mousedown', 'pointerdown', 'pointerup', 'touchend', 'scroll', 'mouseover'];
var ttvcAbort = function ttvcAbort() {
  var vc = getVCObserver();
  if (!vc ||
  // For reasons that goes beyond my understand,
  // the type is not properly set.
  // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/169231
  // @ts-expect-error
  typeof vc.abortCalculation !== 'function') {
    return;
  }

  // For reasons that goes beyond my understand,
  // the type is not properly set.
  // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/169231
  // @ts-expect-error
  vc.abortCalculation();
};
export var disableTTVCOnFirstUserInteraction = function disableTTVCOnFirstUserInteraction() {
  if (typeof window.AbortController !== 'function') {
    return;
  }
  var unbindCallbacks = new Set();
  var controller = new AbortController();
  var unbindFirstInteractionEvents = function unbindFirstInteractionEvents() {
    controller.abort();
    unbindCallbacks.forEach(function (cb) {
      cb();
    });
    unbindCallbacks.clear();
  };
  return new SafePlugin({
    view: function view(_view) {
      if (!_view || !_view.dom) {
        return {};
      }
      var dom = _view.dom;
      for (var _i = 0, _AbortEvent = AbortEvent; _i < _AbortEvent.length; _i++) {
        var abortEventName = _AbortEvent[_i];
        unbindCallbacks.add(bind(dom, abortEventName, controller, function () {
          ttvcAbort();
          unbindFirstInteractionEvents();
        }));
      }
      return {
        destroy: function destroy() {
          unbindFirstInteractionEvents();
        }
      };
    }
  });
};